import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { FileText, Home, Menu, X, List, DollarSign } from 'lucide-react';

const Navbar = () => {
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const location = useLocation();

    const isActive = (path: string) => {
        return location.pathname === path;
    };

    return (
        <nav className="bg-white shadow-md">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="flex justify-between h-16">
                    <div className="flex">
                        <div className="flex-shrink-0 flex items-center">
                            <FileText className="h-8 w-8 text-blue-600" />
                            <span className="ml-2 text-xl font-bold text-gray-900">Generador DDJJ</span>
                        </div>
                        <div className="hidden sm:ml-6 sm:flex sm:space-x-8">
                            <Link
                                to="/"
                                className={`inline-flex items-center px-1 pt-1 border-b-2 text-sm font-medium ${
                                    isActive('/') 
                                        ? 'border-blue-500 text-gray-900' 
                                        : 'border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-700'
                                }`}
                            >
                                <Home className="mr-1 h-4 w-4" />
                                Inicio
                            </Link>
                            <Link
                                to="/form"
                                className={`inline-flex items-center px-1 pt-1 border-b-2 text-sm font-medium ${
                                    isActive('/form') 
                                        ? 'border-blue-500 text-gray-900' 
                                        : 'border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-700'
                                }`}
                            >
                                <FileText className="mr-1 h-4 w-4" />
                                Formulario
                            </Link>
                            <Link
                                to="/cargos"
                                className={`inline-flex items-center px-1 pt-1 border-b-2 text-sm font-medium ${
                                    isActive('/cargos') 
                                        ? 'border-blue-500 text-gray-900' 
                                        : 'border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-700'
                                }`}
                            >
                                <List className="mr-1 h-4 w-4" />
                                Nomenclador
                            </Link>
                            <Link
                                to="/escalas"
                                className={`inline-flex items-center px-1 pt-1 border-b-2 text-sm font-medium ${
                                    isActive('/escalas') 
                                        ? 'border-blue-500 text-gray-900' 
                                        : 'border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-700'
                                }`}
                            >
                                <DollarSign className="mr-1 h-4 w-4" />
                                Escalas
                            </Link>
                        </div>
                    </div>
                    <div className="-mr-2 flex items-center sm:hidden">
                        <button
                            onClick={() => setIsMenuOpen(!isMenuOpen)}
                            className="inline-flex items-center justify-center p-2 rounded-md text-gray-400 hover:text-gray-500 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-blue-500"
                        >
                            <span className="sr-only">Abrir menú principal</span>
                            {isMenuOpen ? (
                                <X className="block h-6 w-6" aria-hidden="true" />
                            ) : (
                                <Menu className="block h-6 w-6" aria-hidden="true" />
                            )}
                        </button>
                    </div>
                </div>
            </div>

            {/* Menú móvil */}
            {isMenuOpen && (
                <div className="sm:hidden">
                    <div className="pt-2 pb-3 space-y-1">
                        <Link
                            to="/"
                            className={`block pl-3 pr-4 py-2 border-l-4 text-base font-medium ${
                                isActive('/') 
                                    ? 'bg-blue-50 border-blue-500 text-blue-700' 
                                    : 'border-transparent text-gray-500 hover:bg-gray-50 hover:border-gray-300 hover:text-gray-700'
                            }`}
                            onClick={() => setIsMenuOpen(false)}
                        >
                            <div className="flex items-center">
                                <Home className="mr-2 h-5 w-5" />
                                Inicio
                            </div>
                        </Link>
                        <Link
                            to="/form"
                            className={`block pl-3 pr-4 py-2 border-l-4 text-base font-medium ${
                                isActive('/form') 
                                    ? 'bg-blue-50 border-blue-500 text-blue-700' 
                                    : 'border-transparent text-gray-500 hover:bg-gray-50 hover:border-gray-300 hover:text-gray-700'
                            }`}
                            onClick={() => setIsMenuOpen(false)}
                        >
                            <div className="flex items-center">
                                <FileText className="mr-2 h-5 w-5" />
                                Formulario
                            </div>
                        </Link>
                        <Link
                            to="/cargos"
                            className={`block pl-3 pr-4 py-2 border-l-4 text-base font-medium ${
                                isActive('/cargos') 
                                    ? 'bg-blue-50 border-blue-500 text-blue-700' 
                                    : 'border-transparent text-gray-500 hover:bg-gray-50 hover:border-gray-300 hover:text-gray-700'
                            }`}
                            onClick={() => setIsMenuOpen(false)}
                        >
                            <div className="flex items-center">
                                <List className="mr-2 h-5 w-5" />
                                Nomenclador
                            </div>
                        </Link>
                        <Link
                            to="/escalas"
                            className={`block pl-3 pr-4 py-2 border-l-4 text-base font-medium ${
                                isActive('/escalas') 
                                    ? 'bg-blue-50 border-blue-500 text-blue-700' 
                                    : 'border-transparent text-gray-500 hover:bg-gray-50 hover:border-gray-300 hover:text-gray-700'
                            }`}
                            onClick={() => setIsMenuOpen(false)}
                        >
                            <div className="flex items-center">
                                <DollarSign className="mr-2 h-5 w-5" />
                                Escalas
                            </div>
                        </Link>
                    </div>
                </div>
            )}
        </nav>
    );
};

export default Navbar;